import axiosInstance from "shared/axios";
import {
  USER_API_URLS,
  PAYMENT_API,
  LOAN_API,
  SUBUSER_API,
  REFUND_API,
  UPLOAD_EXCEL,
  EXPORT_DOWNLOAD_API
} from "shared/constants";
import axios from "axios";
import { queryparamBuilder } from "shared/utils";

export const sendEmailOTP = (email) => {
  return axiosInstance.post(USER_API_URLS.sendOTP, {
    email,
    client_id: process.env.REACT_APP_CLIENT_ID,
    login_source: process.env.REACT_APP_LOGIN_SOURCE,
  });
};

export const sendLogInCred = ({ email, password, otp }) => {
  return axiosInstance.post(USER_API_URLS.logIn, {
    email,
    password,
    otp,
    client_id: process.env.REACT_APP_CLIENT_ID,
    login_source: process.env.REACT_APP_LOGIN_SOURCE,
  });
};
export const getSubUser = (token) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}${USER_API_URLS.subUser}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const tesingPanelApi = ({ method, url, data }) => {
  return axios({
    method: method,
    url: `${url}`,
    data: data,
  });
};

export const getPaymentListingData = (selected, search, param) => {
  let uri = PAYMENT_API.searchPayment
  if(selected){
    if(search == undefined){
      uri += `${selected}`;
    }
    else{
    uri += `?${selected}=${search}&`;
    }
  }
  else if(Object.keys(param)?.length){
    uri += "?"
  }
  uri += queryparamBuilder(param)
  return axiosInstance.get(`${uri}`);
  }

  export const getPaymentListing = (selected, search, param) => {
    let uri = PAYMENT_API.listing
    if(selected){
      if(search == undefined){
        uri += `${selected}`;
      }
      else{
      uri += `?${selected}=${search}&`;
      }
    }
    else if(Object.keys(param)?.length){
      uri += "?"
    }
    uri += queryparamBuilder(param)
    return axiosInstance.get(`${uri}`);
    }
export const getPaymentListingView = ({ selected, search, offset }) => {
let onlyOffset = offset ? `&offset=${offset}`:'';
let fullSearchParam = `${PAYMENT_API.listing}?${selected}=${search}${onlyOffset}`;
return axiosInstance.get(fullSearchParam);
};

export const getRefundListing = (selected, search, params) => {
  let uri = REFUND_API.listing;
  if(selected){
    if(search == undefined){
      uri += `${selected}`;
    }
    else{
    uri += `?${selected}=${search}&`;
    }
  }
  else if(Object.keys(params).length){
    uri += "?"
  }
  uri += queryparamBuilder(params)
  return axiosInstance.get(`${uri}`)
}
export const getExportToExcelList = (payload) => {
  let url =`${EXPORT_DOWNLOAD_API.exportExcel}`;
  return axiosInstance.post(url,payload);
};

export const paymentView = (search) => {
  return axiosInstance.get(`${PAYMENT_API.view}/${search}`);
};

export const viewMappingAPi = (payment_ref_no) => {
  let queryString = `${PAYMENT_API.viewMapping}?payment_reference_number=${payment_ref_no}`;
  return axiosInstance.get(queryString);
};
export const verifyPayment = (payment_ref_no, data) => {
  let queryString = `${PAYMENT_API.verify}/${payment_ref_no}`;
  return axiosInstance.post(queryString, { ...data });
};

export const applyPayment = (payment_ref_no) => {
  let queryString = `${PAYMENT_API.applyPayment}/${payment_ref_no}`;
  return axiosInstance.post(queryString);
};
export const getSubUserByName = (name) => {
  let queryString = `${SUBUSER_API.byName}?name=${name}`;
  return axiosInstance.get(queryString);
};
export const fetchSubUserDropDown = (search_by_name) => {
  let queryString = `${SUBUSER_API.dropSubuser}search_by_name=${search_by_name}&search_by_name_with_role=true`;
  return axiosInstance.get(queryString);
};

export const loanOutstanding = (loan_reference_no) => {
  let queryString = `${LOAN_API.loanOutstanding}/${loan_reference_no}/outstanding-details`;
  return axiosInstance.get(queryString);
};
export const getUserDetails = (source, user_reference_no) => {
  let queryString = `${USER_API_URLS.getOutStandingDetails}/${source}/${user_reference_no}`;
  return axiosInstance.get(queryString);
};
export const loanOutstandingFlipkart = (user_reference_no) => {
  let queryString = `${LOAN_API.loanOutstanding}/${user_reference_no}/flipkart-outstanding-details`;
  return axiosInstance.get(queryString);
};
export const createPromotionalPayment = (data) => {
  return axiosInstance.post(PAYMENT_API.createPromotionalPayment, { ...data });
};
export const createPayment = (data) => {
  return axiosInstance.post(PAYMENT_API.createPayment, { ...data });
};

export const getAllRoles = (selectedFilter, search, params) => {
  let uri = SUBUSER_API.roles;
  if(selectedFilter){
    if(search == undefined){
      uri += `${selectedFilter}`;
    }
    else{
      uri += `?${selectedFilter}=${search}&`;
    }
  }
  else if(Object.keys(params).length){
    uri += "?"
  }
  uri += queryparamBuilder(params)
  return axiosInstance.get(`${uri}`)
}
export const getRoleDetails = (roll_id) => {
  return axiosInstance.get(`${SUBUSER_API.roles}/${roll_id}`);
};

export const getSubUserPermission = (subuser_ref_no) => {
  return axiosInstance.get(`${SUBUSER_API.subuserPermission}${subuser_ref_no}`);
}

export const getLoginRoleDetails = (roll_id, token) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}${SUBUSER_API.roles}/${roll_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
export const getAllPermissions = () => {
  return axiosInstance.get(SUBUSER_API.allPermissions);
};
export const lmsMapping = (payment_ref_no) => {
  return axiosInstance.get(
    `${LOAN_API.lmsMapping}?payment_reference_number=${payment_ref_no}`
  );
};
export const getUserBankAccounts = (user_reference_no) => {
  return axiosInstance.get(
    `${USER_API_URLS.users}/${user_reference_no}/bank-accounts`
  );
};
export const checkUtr = (utr_no, partner,credentialsof) => {
  return axiosInstance.get(
    `${PAYMENT_API.checkUtr}?utr=${utr_no}&partner=${partner || "YESBANK"}&credentials_of=${credentialsof || "arnold"}`
  );
};
export const getBankList = (bank_name) => {
  let URI = PAYMENT_API.bank;
  if (bank_name.length) {
    URI = `${PAYMENT_API.bank}?search_text=${bank_name}`;
  }
  return axiosInstance.get(URI);
};
export const getOperatingBankAccounts = () => {
  // let URI = PAYMENT_API.bank;
  // if (bank_name.length) {
  //   URI = `${PAYMENT_API.bank}?search_text=${bank_name}`;
  // }
  return axiosInstance.get(PAYMENT_API.operatingbank);
};
export const createRefundEntry = (payment_ref_no, data) => {
  return axiosInstance.post(
    `${PAYMENT_API.createRefund}/${payment_ref_no}/create-refund`,
    { ...data }
  );
};
export const creatRole = (data) => {
  return axiosInstance.post(`${SUBUSER_API.roles}`, { ...data });
};
export const updateRole = (roll_id, data) => {
  return axiosInstance.post(`${SUBUSER_API.roles}/${roll_id}`, {
     ...data,
    _method: "patch",
  });
};
export const changeToLoanPayment = (payment_ref_no) => {
  return axiosInstance.post(
    `${PAYMENT_API.view}/${payment_ref_no}/change-to-loan-payment`,
    { _method: "patch" }
  );
};
export const changePaymentReason = (payment_ref_no, data) => {
  return axiosInstance.post(
    `${PAYMENT_API.view}/${payment_ref_no}/change-payment-reason`,
    { _method: "patch", ...data }
  );
};
export const markUnpaidApi = (payment_ref_no) => {
  return axiosInstance.post(
    `${PAYMENT_API.view}/${payment_ref_no}/mark-unpaid`,
    { _method: "patch" }
  );
};
export const paymentReverseApi = (data) => {
  return axiosInstance.post(LOAN_API.paymentReverse, { ...data });
};
export const captureRazorpayPayment = (payment_ref_no) => {
  return axiosInstance.post(
    `${PAYMENT_API.view}/${payment_ref_no}/capture-razorpay-payment`
  );
};
export const getAllPaymentModes = () => {
  return axiosInstance.get(PAYMENT_API.paymentModes);
};

export const fetchAccountApicall = (data) => {
  return axiosInstance.post(PAYMENT_API.accoutData, {...data});
};
export const uploadExcel = (param,data) => {
  if(param == "transaction-deny-upload-excel"){
    return(
       axiosInstance.post(`${UPLOAD_EXCEL.fileUpload}/${param}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    )
  }
  else{
    return(
       axiosInstance.post(`${UPLOAD_EXCEL.fileUpload}/${param}/upload-excel`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    )
  }
  
};
export const sampleFileDownloads = (payload) => {
  let url =`${UPLOAD_EXCEL.samplefile}`;
  return axiosInstance.post(url,payload);
};
export const fileUpload = (data) => {
  return axiosInstance.post(`${UPLOAD_EXCEL.bulkUpload}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
